import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import { defineComponent, reactive, ref, onMounted, onUpdated, openBlock, createElementBlock, normalizeClass, unref, createElementVNode, normalizeStyle, Fragment, renderList, renderSlot, normalizeProps, guardReactiveProps, createTextVNode, toDisplayString, nextTick } from 'vue';
import { useStyleConfig } from '../abstract';
import { useModelValue } from '../vc-utils';
var _hoisted_1 = ["data-key", "onClick"];
var _sfc_main = /*#__PURE__*/defineComponent({
  __name: 'Segmented',
  props: {
    options: Array,
    size: {
      type: String,
      default: 'middle'
    },
    value: [String, Number],
    disabled: Boolean
  },
  emits: ["update:value", "change"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useStyleConfig = useStyleConfig('segmented'),
      prefixCls = _useStyleConfig.prefixCls;
    var getItemValue = function getItemValue(item) {
      return _typeof(item) === 'object' ? item.value : item;
    };
    var _useModelValue = useModelValue(function () {
        return props.value;
      }, function (val) {
        return emit('update:value', val);
      }, getItemValue(props.options[0])),
      _value = _useModelValue.value;
    var bound = reactive({
      left: 0,
      width: 0,
      height: 0
    });
    function updateThumb() {
      var current = container.value.querySelector("*[data-key=".concat(_value.value, "]"));
      nextTick(function () {
        var _current$offsetLeft, _current$clientWidth, _current$clientHeight;
        bound.left = (_current$offsetLeft = current === null || current === void 0 ? void 0 : current.offsetLeft) !== null && _current$offsetLeft !== void 0 ? _current$offsetLeft : 0;
        bound.width = (_current$clientWidth = current === null || current === void 0 ? void 0 : current.clientWidth) !== null && _current$clientWidth !== void 0 ? _current$clientWidth : 0;
        bound.height = (_current$clientHeight = current === null || current === void 0 ? void 0 : current.clientHeight) !== null && _current$clientHeight !== void 0 ? _current$clientHeight : 0;
      });
    }
    function _onClick(e, item) {
      if (props.disabled || _typeof(item) === 'object' && item.disabled) {
        return;
      }
      _value.value = getItemValue(item);
      emit('change', getItemValue(item));
    }
    var container = ref();
    onMounted(updateThumb);
    onUpdated(updateThumb);
    return function (_ctx, _cache) {
      return openBlock(), createElementBlock("div", {
        ref_key: "container",
        ref: container,
        class: normalizeClass("".concat(unref(prefixCls), " ").concat(unref(prefixCls), "-").concat(__props.size, " ").concat(__props.disabled ? 'segmented-disabled' : ''))
      }, [createElementVNode("div", {
        class: normalizeClass("".concat(unref(prefixCls), "-thumb")),
        style: normalizeStyle("left: ".concat(bound.left, "px; width: ").concat(bound.width, "px; height: ").concat(bound.height, "px;"))
      }, null, 6 /* CLASS, STYLE */), (openBlock(true), createElementBlock(Fragment, null, renderList(__props.options, function (item) {
        return openBlock(), createElementBlock("div", {
          "data-key": getItemValue(item),
          key: getItemValue(item),
          class: normalizeClass("".concat(unref(prefixCls), "-item ").concat(unref(_value) === getItemValue(item) ? 'segmented-item-selected' : '', " ").concat(_typeof(item) === 'object' && item.disabled ? 'segmented-item-disabled' : '')),
          onClick: function onClick(e) {
            return _onClick(e, item);
          }
        }, [renderSlot(_ctx.$slots, "renderItem", normalizeProps(guardReactiveProps({
          item: item,
          value: unref(_value)
        })), function () {
          return [createTextVNode(toDisplayString(_typeof(item) === 'object' ? item.label : item), 1 /* TEXT */)];
        })], 10 /* CLASS, PROPS */, _hoisted_1);
      }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */);
    };
  }
});

var _export_sfc = function _export_sfc(sfc, props) {
  var target = sfc.__vccOpts || sfc;
  var _iterator = _createForOfIteratorHelper(props),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        val = _step$value[1];
      target[key] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return target;
};
var Segmented = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "/Users/chenghongxing/VsCodeProjects/stepin/components/segmented/Segmented.js"]]);
export { Segmented as default };